/**
 * root.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

// Import all the third party stuff
import * as ReactDOM from "react-dom/client";

import { Provider, App as AntdApp } from "react-redux";
// import FontFaceObserver from 'fontfaceobserver';
import { ConfigProvider, notification } from "antd";
import "sanitize.css/sanitize.css";
import "theme/custom.css";
import "antd/dist/reset.css";

import frFR from "antd/locale/fr_FR";
import itIT from "antd/locale/it_IT";

import "dayjs/locale/fr-ch";
import "./utils/prototypeOverride";

import App from "./engine/App";

// Load the favicon and the .htaccess file
import "!file-loader?name=[name].[ext]!public/favicon.ico";
import "file-loader?name=.htaccess!public/.htaccess"; // eslint-disable-line import/extensions
// root
import { storeNew } from "store/store.new";

import "engine/i18n";
import AppProviders from "./engine/context/AppProviders";
import { LoadingIndex } from "./shared/components/LoadingIndex";
import { ModalsDynamic } from "./shared/components/Modals/ModalsDynamic";
import LanguageSelector from "./shared/components/LanguageSelector";
import React from "react";
import moment from "moment";
import dayjs from "dayjs";
import { getLanguageConfig, getLanguageInit } from "./engine/customerConfig";

const root = ReactDOM.createRoot(document.getElementById("app"));

//
export const colorPrimary = "#F93B3D";
const root_theme = document.querySelector(":root");

// Set default notification duration (in seconds)
notification.config({
  duration: 5, // Default duration of 5 seconds
});

root_theme.style.setProperty("--color-primary", colorPrimary);

// get the current language
const language = getLanguageInit();

let lang = frFR;

if (language === "it") {
  lang = itIT;
  dayjs.locale("it");
}

root.render(
  <AppProviders>
    <Provider store={storeNew}>
      <ConfigProvider
        locale={lang}
        theme={{
          token: {
            borderRadius: 2,
            colorBorder: "#a79e9e",
            controlHeight: 40,
            colorPrimary: colorPrimary,
            colorTextSecondary: "#262626",
            colorTextBase: "#262626",
            colorText: "#565556",
            colorTextHeading: "#262626",
            colorTextLabel: "#000000",
            //colorBgContainer: '#F8F8F8',
            colorBgLayout: "#F8F8F8",
            colorLink: "#F93B3D",
            colorLinkHover: "#fd7172",
            linkHoverDecoration: "underline",
          },
        }}
      >
        <LoadingIndex>
          <App />
          <ModalsDynamic />
        </LoadingIndex>
      </ConfigProvider>
    </Provider>
  </AppProviders>,
);
